import { FC } from 'react'
import { cn } from '@wellesley/ui'
import { CoverImage, CoverImageProps } from 'components/CoverImage'
import placeholderImage from './placeholder.png'

type EventCoverProps = Omit<CoverImageProps, 'src'> & {
  src?: string | null
}

export const EventCover: FC<EventCoverProps> = ({
  src,
  children,
  className,
  ...rest
}) => (
  <CoverImage
    src={src || placeholderImage}
    alt="Event cover"
    data-testid="event-cover"
    className={cn(
      className,
      'bg-alpha-black-10 [&_img]:[mask-image:linear-gradient(to_bottom,black_70%,transparent_120%)]',
    )}
    {...rest}
  >
    {children}
  </CoverImage>
)
